import { useGlobalState } from "../../../services/context/AuthContext";
import React from "react";

interface DashboardRecentBookingProps {
  data: any[];
}

const DashboardRecentBooking = ({ data }: DashboardRecentBookingProps) => {
  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";
  return (
    <div className="py-2 scrollable-x-auto">
      <table className="table table-hover mb-0">
        <thead className="bg-light">
          <tr>
            <th scope="col">Passenger</th>
            <th scope="col">Route</th>
            <th scope="col">Departure</th>
            <th scope="col">Booking Date</th>
            <th scope="col">Amount</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>
                  <div className="sort">{item.passenger_name}</div>
                </td>
                <td>
                  <div className="sort">{item.route}</div>
                </td>
                <td>
                  <div className="sort">
                    {new Date(item.departure_date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </div>
                </td>
                <td>
                  <div className="sort">
                    {new Date(item.booking_date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </div>
                </td>
                <td>
                  <div className="sort">{currency} {item.amount}</div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center text-muted">
                No recent bookings
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardRecentBooking;
